import React from 'react';
import { MenuItem, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import { WideBox, FlexDiv } from '../../styles/styles';
import DealForm from '../DealForm';
import { safeEval } from '../../util/UtilFunctions';

const NewDeal = () => {
  const history = useHistory();
  const { authStore } = useRootStore();

  return (
    <FlexDiv>
      <WideBox style={{ maxWidth: '500px' }}>
        <DealForm
          onSubmit={async values => {
            const {
              Title,
              DealNumber,
              Description,
              ContractDate,
              TransactionDate,
              BillableDate,
              PayableDate,
              AgentContactId,
              AgentContact,
              ApprovedBy,
              StatusId,
            } = values;
            try {
              const { data } = await authStore.request.post(
                `${process.env.REACT_APP_API}/api/deal`,
                {
                  Title,
                  DealNumber,
                  Description,
                  ContractDate,
                  TransactionDate,
                  BillableDate,
                  PayableDate,
                  AgentContactId,
                  ApprovedBy,
                  StatusId,
                  AgentContact,
                },
              );
              const { id } = data;
              history.push(`/deal/${id}`, { dealTranEditMode: true });
            } catch (e) {
              console.error(e);
            }
          }}
          buttons={[
            <Button
              color="secondary"
              variant="outlined"
              size="large"
              style={{
                margin: '5px',
              }}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>,
          ]}
          menuItems={[
            <MenuItem
              key={1}
              onClick={() => history.push(`/new-deal-from-template`)}
            >
              Use Deal Template
            </MenuItem>,
          ]}
        />
      </WideBox>
    </FlexDiv>
  );
};

export default NewDeal;
